import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from "react-redux";
import _ from "lodash";
import Piechart from "components/charts/PieChart";
import { filterMainResultsByLawyerIds } from "state/actions/searchActions"
import { useTestObjectRef, BI } from 'utils/testUtils';
import { getLawyerCollegeCount } from 'pages/utils/lawyerCollegeCount';
import color from "utils/color";
import { createLoadingSelector } from "../../state/selectors/loadingSelector";
import NoRecordFound from "../../components/NoRecordFound";

const CollegeBi = ({ isOverlay = false }) => {
    const chartRef = useTestObjectRef(BI.PSF_COLLEGES_CHART);
    const currentCollegesResults = useSelector(state => state.search.currentYearsCollegesResults);
    const dispatch = useDispatch();
    const store = useStore();
    const [stats, setStats] = useState([]);
    const filterByLawyerIds = legendItem => {
        const result = store.getState().search.currentYearsCollegesResults;
        if (result) {
            const lawyerIds = result.filter(item => item.attbr === legendItem.text).map(item => item.lId);
            dispatch(filterMainResultsByLawyerIds(lawyerIds));
        }
    }
    const loadingSelector = createLoadingSelector(['COLLEGES_DATA_BY_SEARCH']);
    const loading = useSelector(state => loadingSelector(state));
    useEffect(() => {
        async function getStats() {
            if (currentCollegesResults) {
                let top = 5;
                if(isOverlay)
                    top = 0;
                let result = getLawyerCollegeCount(currentCollegesResults, top, true);
                setStats(result);
            }
        }

        getStats();
    }, [currentCollegesResults]);
    return (
        <div id="psfColleges" style={{marginBottom: '20%'}}>
            {loading && <span wk-icon="spinner" className="wk-spin" style={{ "verticalAlign": "middle" }}/>}
            {!loading && stats.length > 0 && <Piechart
                label="Colleges"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.college)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]}/>}
            {!loading && !stats.length && <NoRecordFound/>}
        </div>
    );
};
export default CollegeBi;
